/**
 * Product Form Component
 */
(function () {
  "use strict";

  const ProductForm = {
    init() {
      // Handle product form submissions
      document.querySelectorAll("[data-product-form]").forEach((form) => {
        form.addEventListener("submit", async (e) => {
          e.preventDefault();

          const submitButton = form.querySelector("[data-add-to-cart]");
          if (!submitButton || submitButton.disabled) return;

          const variantSelect = form.querySelector("[data-variant-select]");
          if (!variantSelect) return;

          const variantId = variantSelect.value;
          if (!variantId) return;

          const addItemOptions = {};
          const sellingPlanInput = form.querySelector('[name="selling_plan"]');
          if (sellingPlanInput && sellingPlanInput.value) {
            addItemOptions.selling_plan = sellingPlanInput.value;
          }

          const properties = {};
          form.querySelectorAll('[name^="properties["]').forEach((input) => {
            const name = input.getAttribute("name") || "";
            const match = name.match(/^properties\[(.*)\]$/);
            if (!match) return;

            const propertyName = match[1];
            const value = input.value;
            if (propertyName && value !== "") {
              properties[propertyName] = value;
            }
          });

          if (Object.keys(properties).length > 0) {
            addItemOptions.properties = properties;
          }

          // Disable button during submission
          const originalText = submitButton.innerHTML;
          submitButton.disabled = true;
          submitButton.classList.add("opacity-50");

          try {
            await window.CartAPI.addItem(variantId, 1, addItemOptions);

            // Open cart drawer
            if (window.CartDrawer) {
              window.CartDrawer.open();
            }

            // Reset button
            submitButton.disabled = false;
            submitButton.classList.remove("opacity-50");
          } catch (error) {
            console.error("Error adding to cart:", error);
            alert(
              "There was an error adding this item to your cart. Please try again."
            );

            // Reset button
            submitButton.disabled = false;
            submitButton.classList.remove("opacity-50");
          }
        });
      });
    },
  };

  window.ProductForm = ProductForm;
})();

